import { http } from "@next-core/http";
/**
 * @description 更新服务对象实例
 * @endpoint PUT /api/v1/elevo/objects/:objectId/instances/:instanceId
 */
export const ElevoObjectApi_updateServiceObjectInstance = (objectId, instanceId, data, options) => /**! @contract easyops.api.llm.elevo_object.UpdateServiceObjectInstance@1.0.0 */http.put(`api/gateway/logic.llm.aiops_service/api/v1/elevo/objects/${objectId}/instances/${instanceId}`, data, options);
//# sourceMappingURL=updateServiceObjectInstance.js.map